import axios from '../request/http';

const blindBox = {
    // 盲盒列表
    bingList(params) {
        return axios.get("/admin/blind-box/list", {params});
    },
    // 更新盲盒状态
    changeBindStatus(params) {
        return axios.get("/admin/blind-box/update-status", {params});
    },
    // 新增盲盒
    bindAdd(data) {
        return axios.post("/admin/blind-box/edit", data);
    },
    // 盲盒产品列表
    bindProductList(params) {
        return axios.get("/admin/blind-box/goods/list", {params});
    },
    // 盲盒酒水产品
    blindProductEdit(data) {
        return axios.post("/admin/blind-box/goods/edit", data);
    },
    bindProductStatus(params) {
        return axios.get("/admin/blind-box/goods/update-status", {params});
    },
    // 盲盒酒水的产出率
    blindProductRate(params) {
        return axios.get("/admin/blind-box/goods/update-rate", {params});
    },
    // 盲盒商品更新
    BlindProductAdd(data) {
        return axios.post("/admin/blind-box/update-goods", data);
    },
    // 邀请关系列表
    assistList(params) {
        return axios.get("/admin/blind-box/assist/list", {params});
    },
    // 盲盒券列表
    blindCouponList(params) {
        return axios.get("/admin/blind-box/coupon/list", {params});
    },
    // 盲盒券新增/编辑
    blindCouponListEdit(data) {
        return axios.post("/admin/blind-box/coupon/edit", data);
    },
    // 盲盒券状态更新
    blindStatus(params) {
        return axios.get("/admin/blind-box/coupon/status-update", {params});
    },
    // 酒后人生名言
    blindNewsList(params) {
        return axios.get("/admin/blind-box/news/list", {params});
    },
    // 酒后人生名言状态更新
    blindStatusUpdate(params) {
        return axios.get("/admin/blind-box/news/status-update", {params});
    },
    // 酒后人生名言新增编辑
    blindNewsListAdd(data) {
        return axios.post("/admin/blind-box/new/edit", data);
    },
    // 盲盒订单发货列表
    deliverList(params) {
        return axios.get("/admin/blind-box/orderList", {params});
    },
}

export default blindBox;


// WEBPACK FOOTER //
// ./src/api/blindBox.js